<h1 mat-dialog-title class="notification-title no-select">
	{{ 'mes.administration.calendar.delete-calendar.heading' | translate }}
</h1>
<div mat-dialog-content>
	<p>
		{{ 'mes.administration.calendar.delete-calendar.content' | translate: { alias: calendar.alias } }}
	</p>
</div>
<div mat-dialog-actions>
	<button mat-flat-button color="primary" (click)="onDelete()" (window:keyup.enter)="onDelete()" [disabled]="loading">
		{{ 'mes.administration.calendar.dialog.okbtn' | translate }}
	</button>
	<button mat-flat-button color="primary" (click)="onCancel()" (window:keyup.escape)="onCancel()">
		{{ 'mes.administration.calendar.dialog.cancelbtn' | translate }}
	</button>
</div>
